import { CSSProperties } from 'react';

export const navLinkStyle: CSSProperties = {
  color: 'var(--colors-blue7)',
  pointerEvents: 'none',
  opacity: 0.85,
};
